import { create } from 'zustand'

interface ModalState {
   isActiveLeadDetailsModalOpen: boolean
   campaignName: string | null
   campaignId: string | null
   statType: 'source' | 'campaign' | null
   openActiveLeadDetailsModal: (campaignName: string, campaignId: string | null, statType: 'source' | 'campaign') => void
   closeActiveLeadDetailsModal: () => void
}

export const useActiveLeadDetailsModalStore = create<ModalState>((set) => ({
   isActiveLeadDetailsModalOpen: false,
   campaignName: null,
   campaignId: null,
   statType: null,
   openActiveLeadDetailsModal: (campaignName, campaignId, statType) =>
      set({
         isActiveLeadDetailsModalOpen: true,
         campaignName,
         campaignId,
         statType,
      }),
   closeActiveLeadDetailsModal: () =>
      set({
         isActiveLeadDetailsModalOpen: false,
         campaignName: null,
         campaignId: null,
         statType: null,
      }),
}))